import React from 'react';
import MenuPizza from '../componets/MenuPizza'
import '../App.css';

function Consumer(props) {

  return (
    <React.Fragment key={1}>
      <MenuPizza/>
    </React.Fragment>
  );
}

export default Consumer;
